<div class="saru-editor">
  <div class="saru-editor__header">
    <div>
      <h4 class="saru-editor__title">Configure Row #{{ row.rowNumber }}</h4>
      <p class="saru-editor__subtitle">{{ parsed.recipeName || 'Untitled recipe' }}</p>
    </div>
    <button type="button" class="saru-editor__close" (click)="activeModal.dismiss()" aria-label="Close">
      <i data-lucide="x"></i>
    </button>
  </div>

  <div class="saru-editor__main">
    <aside class="saru-editor__nav">
      <div class="saru-editor__nav-title">Sections</div>
      <button
        *ngFor="let t of editorTabs; let i = index"
        type="button"
        class="saru-editor__nav-item"
        [class.saru-editor__nav-item--active]="activeTab === t.id"
        [class.saru-editor__nav-item--error]="hasSectionError(t.id)"
        (click)="setTab(t.id)"
      >
        <span class="saru-editor__nav-num">{{ i + 1 }}</span>
        <span class="saru-editor__nav-label">{{ t.short }}</span>
      </button>
    </aside>

    <div class="saru-editor__content">
      <div class="saru-editor__content-head">
        <h5 class="saru-editor__content-title">{{ activeTabLabel }}</h5>
      </div>

      <div class="saru-editor__body">
        <div class="saru-section-errors" *ngIf="sectionErrorMessages.length">
          <div class="saru-section-errors__title">Please fix the following:</div>
          <ul>
            <li *ngFor="let msg of sectionErrorMessages">{{ msg }}</li>
          </ul>
        </div>

    <!-- Section 1 Classification -->
    <div *ngIf="activeTab === 1" class="saru-editor__section">
      <div class="saru-field" [class.saru-field--error]="hasFieldError('healthColorCodeId')">
        <label>Health Color Code</label>
        <ng-select [items]="lookups.healthColorCodes" bindLabel="name" bindValue="id"
          placeholder="Select health color code" [(ngModel)]="selections.healthColorCodeId"
          (ngModelChange)="clearFieldError('healthColorCodeId')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('healthColorCodeId')">{{ getFieldError('healthColorCodeId') }}</div>
      </div>
      <div class="saru-field">
        <label>Dietary Preference</label>
        <ng-select [items]="lookups.dietaryPreferences" bindLabel="name" bindValue="id"
          placeholder="Select dietary preference" [(ngModel)]="selections.dietaryPreferenceId"
          [clearable]="true" appendTo="body"></ng-select>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('mealTypeIds')">
        <label>Meal Type</label>
        <ng-select [items]="lookups.mealTypes" bindLabel="name" bindValue="id"
          placeholder="Select meal type" [(ngModel)]="selections.mealTypeIds"
          (ngModelChange)="clearFieldError('mealTypeIds')"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('mealTypeIds')">{{ getFieldError('mealTypeIds') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('sourceId')">
        <label>Source</label>
        <ng-select [items]="lookups.sources" bindLabel="name" bindValue="id"
          placeholder="Select source" [(ngModel)]="selections.sourceId"
          (ngModelChange)="clearFieldError('sourceId')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('sourceId')">{{ getFieldError('sourceId') }}</div>
      </div>
      <div class="saru-field">
        <label>Recipe Category</label>
        <ng-select [items]="lookups.recipeCategories" bindLabel="name" bindValue="id"
          placeholder="Select category" [(ngModel)]="selections.recipeCategoryIds"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Meal Preference</label>
        <ng-select [items]="lookups.mealPreferences" bindLabel="name" bindValue="id"
          placeholder="Select meal preference" [(ngModel)]="selections.mealPreferenceIds"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Food Group</label>
        <ng-select [items]="lookups.foodGroups" bindLabel="name" bindValue="id"
          placeholder="Select food group" [(ngModel)]="selections.foodGroupIds"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>FAO Food Group</label>
        <ng-select [items]="lookups.faoFoodGroups" bindLabel="name" bindValue="id"
          placeholder="Select FAO food group" [(ngModel)]="selections.faoFoodGroupIds"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-readonly" [class.saru-field--error]="hasFieldError('recipeName') || hasFieldError('numberOfServes') || hasFieldError('recipeDescription')">
        <div><strong>Recipe Name:</strong> {{ parsed.recipeName || '—' }}</div>
        <div><strong>Serves:</strong> {{ parsed.numberOfServes || '—' }}</div>
        <div><strong>Description:</strong> {{ parsed.recipeDescription || '—' }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('recipeName')">{{ getFieldError('recipeName') }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('numberOfServes')">{{ getFieldError('numberOfServes') }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('recipeDescription')">{{ getFieldError('recipeDescription') }}</div>
      </div>
    </div>

    <!-- Section 2 -->
    <div *ngIf="activeTab === 2" class="saru-editor__section">
      <div class="saru-field">
        <label>Cooking Process</label>
        <ng-select [items]="lookups.cookingMethods" bindLabel="name" bindValue="id"
          placeholder="Select process" [(ngModel)]="selections.cookingMethodIds"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Utensils</label>
        <ng-select [items]="lookups.utensils" bindLabel="name" bindValue="id"
          placeholder="Select utensils" [(ngModel)]="selections.utensilIds"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Equipment</label>
        <ng-select [items]="lookups.equipment" bindLabel="name" bindValue="id"
          placeholder="Select equipment" [(ngModel)]="selections.equipmentIds"
          [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-readonly">
        <div><strong>Prep:</strong> {{ parsed.prepTime || '—' }}</div>
        <div><strong>Cook:</strong> {{ parsed.cookTime || '—' }}</div>
      </div>
    </div>

    <!-- Section 3 -->
    <div *ngIf="activeTab === 3" class="saru-editor__section">
      <div class="saru-field">
        <label>Taste Profile</label>
        <ng-select [items]="lookups.tastes" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.tasteIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Texture</label>
        <ng-select [items]="lookups.textures" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.textureIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Flavour</label>
        <ng-select [items]="lookups.flavours" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.flavourIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Aroma</label>
        <ng-select [items]="lookups.aromas" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.aromaIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
    </div>

    <!-- Section 4 -->
    <div *ngIf="activeTab === 4" class="saru-editor__section">
      <p *ngIf="geoLoading" class="saru-hint">Loading geo data…</p>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('cuisineContinentIds')">
        <label>Continent</label>
        <ng-select [items]="lookups.continents" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.cuisineContinentIds" [multiple]="true" [closeOnSelect]="false"
          (ngModelChange)="onContinentChange(); clearFieldError('cuisineContinentIds')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('cuisineContinentIds')">{{ getFieldError('cuisineContinentIds') }}</div>
      </div>
      <div class="saru-field">
        <label>Region</label>
        <ng-select [items]="regionOptions" bindLabel="name" bindValue="name"
          [(ngModel)]="selections.cuisineRegionLabels" [multiple]="true" [closeOnSelect]="false"
          (ngModelChange)="onRegionChange()" [disabled]="!regionOptions.length" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Sub Region</label>
        <ng-select [items]="subRegionOptions" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.cuisineSubRegionIds" [multiple]="true" [closeOnSelect]="false"
          (ngModelChange)="onSubRegionChange()" [disabled]="!subRegionOptions.length" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Cuisine</label>
        <ng-select [items]="cuisineGeoTagOptions" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.cuisineGeoTagIds" [multiple]="true" [closeOnSelect]="false"
          [disabled]="!cuisineGeoTagOptions.length" appendTo="body"></ng-select>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('occasionIds')">
        <label>Occasion</label>
        <ng-select [items]="lookups.occasions" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.occasionIds" [multiple]="true" [closeOnSelect]="false"
          (ngModelChange)="clearFieldError('occasionIds')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('occasionIds')">{{ getFieldError('occasionIds') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('locationIds')">
        <label>Location</label>
        <ng-select [items]="lookups.locations" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.locationIds" [multiple]="true" [closeOnSelect]="false"
          (ngModelChange)="clearFieldError('locationIds')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('locationIds')">{{ getFieldError('locationIds') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('seasonIds')">
        <label>Season</label>
        <ng-select [items]="lookups.seasons" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.seasonIds" [multiple]="true" [closeOnSelect]="false"
          (ngModelChange)="clearFieldError('seasonIds')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('seasonIds')">{{ getFieldError('seasonIds') }}</div>
      </div>
    </div>

    <!-- Section 5 -->
    <div *ngIf="activeTab === 5" class="saru-editor__section">
      <div class="saru-field">
        <label>Allergens (Contains)</label>
        <ng-select [items]="lookups.allergens" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.allergenContainsIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Allergens (Free)</label>
        <ng-select [items]="lookups.allergenFree" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.allergenFreeIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Intolerances (Contains)</label>
        <ng-select [items]="lookups.intolerances" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.intoleranceContainsIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Intolerances (Free)</label>
        <ng-select [items]="lookups.intoleranceFree" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.intoleranceFreeIds" [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
      </div>
    </div>

    <!-- Section 6 Notes & Chef Details (from Excel Professional Notes / Chef columns) -->
    <div *ngIf="activeTab === 6" class="saru-editor__section saru-editor__section--notes">
      <p class="saru-hint" *ngIf="!hasNotesContent">
        No Professional Notes / Chef Method / Author Notes / Tips / Remark found in the uploaded file for this row.
      </p>

      <div class="saru-notes-block" *ngIf="professionalNotesPreview.length">
        <div class="saru-notes-block__title">Professional Notes (preview)</div>
        <div class="saru-note-card" *ngFor="let note of professionalNotesPreview">
          <div class="saru-note-card__heading" *ngIf="note.title">{{ note.title }}</div>
          <div class="saru-note-card__body">{{ note.body || '—' }}</div>
        </div>
      </div>

      <div class="saru-field saru-field--full">
        <label>Professional Notes (editable — Title|Body, multiple notes with ;;)</label>
        <textarea
          rows="5"
          [(ngModel)]="parsed.professionalNotes"
          placeholder="Know Your Nutrition|Body text here;;Another Title|Another body"
        ></textarea>
      </div>

      <div class="saru-notes-block" *ngIf="chefMethodPreview.length">
        <div class="saru-notes-block__title">Chef Method Processes (preview)</div>
        <div class="saru-note-card" *ngFor="let process of chefMethodPreview">
          <div class="saru-note-card__heading">{{ process.name || 'Cooking Process' }}</div>
          <ol class="saru-note-card__steps">
            <li *ngFor="let step of process.steps">{{ step }}</li>
          </ol>
        </div>
      </div>

      <div class="saru-field saru-field--full">
        <label>Chef Method Processes (editable — steps separated by | )</label>
        <textarea
          rows="4"
          [(ngModel)]="parsed.chefMethodProcesses"
          placeholder="Step 1 | Step 2 | Step 3"
        ></textarea>
      </div>

      <div class="saru-notes-block" *ngIf="chefAuthorNotesList.length">
        <div class="saru-notes-block__title">Chef Author Notes (preview)</div>
        <ul class="saru-note-list">
          <li *ngFor="let n of chefAuthorNotesList">{{ n }}</li>
        </ul>
      </div>

      <div class="saru-field saru-field--full">
        <label>Chef Author Notes (editable — separate with ; or | )</label>
        <textarea
          rows="3"
          [(ngModel)]="parsed.chefAuthorNotes"
          placeholder="Skill level: Moderate; Place of origin: India"
        ></textarea>
      </div>

      <div class="saru-notes-block" *ngIf="chefAuthorTipsList.length">
        <div class="saru-notes-block__title">Chef Author Tips (preview)</div>
        <ul class="saru-note-list">
          <li *ngFor="let t of chefAuthorTipsList">{{ t }}</li>
        </ul>
      </div>

      <div class="saru-field saru-field--full">
        <label>Chef Author Tips (editable — separate with ; or | )</label>
        <textarea
          rows="3"
          [(ngModel)]="parsed.chefAuthorTips"
          placeholder="Tip 1 | Tip 2 | Tip 3"
        ></textarea>
      </div>

      <div class="saru-field saru-field--full">
        <label>Remark</label>
        <textarea
          rows="3"
          [(ngModel)]="parsed.remark"
          placeholder="Mapping / internal remark from file"
        ></textarea>
      </div>
    </div>

    <!-- Section 8 Ingredients + UOM -->
    <div *ngIf="activeTab === 8" class="saru-editor__section saru-editor__section--ingredients">
      <div class="saru-field__error saru-field__error--block" *ngIf="hasFieldError('recipeIngredients')">
        {{ getFieldError('recipeIngredients') }}
      </div>
      <div class="saru-csv-hint" *ngIf="selections.ingredients?.length">
        <strong>From file:</strong>
        <span *ngFor="let ing of selections.ingredients; let last = last">
          {{ ing.name }}{{ ing.quantity ? ' (' + ing.quantity + (ing.unitLabel ? ' ' + ing.unitLabel : '') + ')' : '' }}<span *ngIf="!last">, </span>
        </span>
      </div>

      <!-- Ingredients header -->
      <div class="ingredients-header">
        <div class="ingredients-header__left">
          <h5 class="ingredients-header__title">Recipe Ingredients</h5>
          <p class="ingredients-header__subtitle">Loaded from file when present. Link to master ingredients if needed.</p>
          <span class="ingredients-header__count" *ngIf="recipeIngredients?.length">
            {{ recipeIngredients.length }} item{{ recipeIngredients.length > 1 ? 's' : '' }}
          </span>
        </div>
        <button type="button" class="btn-add-ingredient" (click)="openIngredientDialog()">
          <i class="ft-plus"></i> Add Ingredient
        </button>
      </div>

      <!-- Empty state -->
      <div *ngIf="!recipeIngredients?.length" class="ingredients-empty">
        <div class="ingredients-empty__icon"><i class="ft-package"></i></div>
        <h5 class="ingredients-empty__title">No ingredients added yet</h5>
        <p class="ingredients-empty__text">Add ingredients with unit, quantity and auto-calculated nutrition values.</p>
        <button type="button" class="btn-add-ingredient btn-add-ingredient--ghost" (click)="openIngredientDialog()">
          <i class="ft-plus"></i> Add your first ingredient
        </button>
      </div>

      <!-- Ingredients list -->
      <div class="ingredients-list" *ngIf="recipeIngredients?.length">
        <div class="ingredient-card" *ngFor="let ing of recipeIngredients; let i = index">
          <div class="ingredient-card__index">{{ i + 1 }}</div>
          <div class="ingredient-card__body">
            <div class="ingredient-card__name">{{ ing.ingredientName }}</div>
            <div class="ingredient-card__meta">
              <span class="ingredient-meta-chip">
                <i class="ft-hash"></i> {{ ing.quantity }} × {{ ing.unitLabel }}
              </span>
              <span class="ingredient-meta-chip ingredient-meta-chip--highlight">
                <i class="ft-zap"></i> {{ formatIngredientMacro(ing.totalGrams) }}g
              </span>
            </div>
          </div>
          <div class="ingredient-card__nutrition">
            <div class="nutrition-pill nutrition-pill--cal">
              <span class="nutrition-pill__value">{{ formatIngredientMacro(ing.calories) }}</span>
              <span class="nutrition-pill__label">kcal</span>
            </div>
            <div class="nutrition-pill nutrition-pill--carb">
              <span class="nutrition-pill__value">{{ formatIngredientMacro(ing.carbs) }}</span>
              <span class="nutrition-pill__label">carbs</span>
            </div>
            <div class="nutrition-pill nutrition-pill--protein">
              <span class="nutrition-pill__value">{{ formatIngredientMacro(ing.protein) }}</span>
              <span class="nutrition-pill__label">protein</span>
            </div>
            <div class="nutrition-pill nutrition-pill--fat">
              <span class="nutrition-pill__value">{{ formatIngredientMacro(ing.fat) }}</span>
              <span class="nutrition-pill__label">fat</span>
            </div>
            <div class="nutrition-pill nutrition-pill--fiber">
              <span class="nutrition-pill__value">{{ formatIngredientMacro(ing.fiber) }}</span>
              <span class="nutrition-pill__label">fiber</span>
            </div>
          </div>
          <div class="ingredient-card__actions">
            <button type="button" class="ingredient-action-btn ingredient-action-btn--edit"
              (click)="openIngredientDialog(i)" title="Edit">
              <i class="ft-edit-2"></i>
            </button>
            <button type="button" class="ingredient-action-btn ingredient-action-btn--delete"
              (click)="deleteRecipeIngredient(i)" title="Delete">
              <i class="ft-trash-2"></i>
            </button>
          </div>
        </div>

        <!-- Total nutritional summary -->
        <div class="ingredients-totals-card">
          <div class="ingredients-totals-card__header">
            <i class="ft-bar-chart-2"></i>
            <span>Total Nutritional Summary</span>
          </div>
          <div class="ingredients-totals-card__grid">
            <div class="total-stat">
              <span class="total-stat__value">{{ formatIngredientMacro(ingredientTotals.totalGrams) }}g</span>
              <span class="total-stat__label">Total Weight</span>
            </div>
            <div class="total-stat total-stat--cal">
              <span class="total-stat__value">{{ formatIngredientMacro(ingredientTotals.calories) }}</span>
              <span class="total-stat__label">Calories (kcal)</span>
            </div>
            <div class="total-stat total-stat--carb">
              <span class="total-stat__value">{{ formatIngredientMacro(ingredientTotals.carbs) }}g</span>
              <span class="total-stat__label">Carbohydrates</span>
            </div>
            <div class="total-stat total-stat--protein">
              <span class="total-stat__value">{{ formatIngredientMacro(ingredientTotals.protein) }}g</span>
              <span class="total-stat__label">Protein</span>
            </div>
            <div class="total-stat total-stat--fat">
              <span class="total-stat__value">{{ formatIngredientMacro(ingredientTotals.fat) }}g</span>
              <span class="total-stat__label">Fat</span>
            </div>
            <div class="total-stat total-stat--fiber">
              <span class="total-stat__value">{{ formatIngredientMacro(ingredientTotals.fiber) }}g</span>
              <span class="total-stat__label">Fiber</span>
            </div>
          </div>

          <div class="fssai-generated-tags">
            <div class="row align-items-end">
              <div class="col-md-4">
                <label class="form-label mb-1">State of Product</label>
                <ng-select class="saru-state-select"
                  [(ngModel)]="selections.stateOfProduct"
                  (ngModelChange)="onStateOfProductChange()"
                  [items]="stateOfProductOptions"
                  bindLabel="value"
                  bindValue="value"
                  [clearable]="false"
                  [searchable]="false">
                </ng-select>
              </div>
              <div class="col-md-8">
                <label class="form-label mb-1">FSSAI Nutrient Tags (auto-generated)</label>
                <div class="nutrition-fssai-corner__hint text-muted small mb-1" *ngIf="selections.stateOfProduct">
                  All cut-offs ({{ nutritionBasisLabel }}) — from total recipe ingredients
                </div>
                <div class="fssai-generated-tags__chips">
                  <span class="text-muted small" *ngIf="!selections.stateOfProduct">
                    Select State of Product to calculate FSSAI nutrient tags.
                  </span>
                  <span class="text-muted small" *ngIf="selections.stateOfProduct && isLoadingGeneratedFssaiTags">Calculating tags…</span>
                  <ng-container *ngIf="selections.stateOfProduct && !isLoadingGeneratedFssaiTags && generatedFssaiNutrientTags?.length; else noBulkFssaiTags">
                    <span class="fssai-generated-tag-chip"
                      [ngClass]="getFssaiTagChipClass(tag)"
                      *ngFor="let tag of generatedFssaiNutrientTags">
                      {{ tag.fssaiTagName }}
                    </span>
                  </ng-container>
                  <ng-template #noBulkFssaiTags>
                    <span class="text-muted small" *ngIf="selections.stateOfProduct && !isLoadingGeneratedFssaiTags">
                      No FSSAI nutrient tags matched.
                    </span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Recipe UOM section -->
      <div class="saru-uom-section">
        <div class="ingredients-header">
          <div class="ingredients-header__left">
            <h5 class="ingredients-header__title">Recipe UOM (Unit of Measure)</h5>
            <p class="ingredients-header__subtitle">Define serving sizes for this recipe (e.g., 1 Bowl = 250g)</p>
          </div>
          <button type="button" class="btn-add-ingredient" (click)="openRecipeUomDialog()">
            <i class="ft-plus"></i> Add Recipe UOM
          </button>
        </div>

        <div class="measurement-table-wrapper" *ngIf="recipeUoms.length > 0">
          <table class="measurement-premium-table w-100">
            <thead>
              <tr>
                <th class="text-center" style="width: 70px;">Preferred</th>
                <th>Category</th>
                <th>Sub Category</th>
                <th style="width: 130px;">Value (gm)</th>
                <th class="text-center" style="width: 60px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let uom of recipeUoms; let i = index">
                <td class="text-center">
                  <div class="custom-control custom-radio d-inline-block">
                    <input type="radio" class="custom-control-input"
                      [id]="'bulk-uom-pref-' + row.rowNumber + '-' + i"
                      [name]="'bulkUomPreferred' + row.rowNumber"
                      [checked]="uom.isPreferred"
                      (change)="onRecipeUomPreferredChange(i)">
                    <label class="custom-control-label" [for]="'bulk-uom-pref-' + row.rowNumber + '-' + i"></label>
                  </div>
                </td>
                <td>{{ uom.categoryName }}</td>
                <td>
                  {{ uom.subcategoryName }}
                  <span *ngIf="uom.ml > 0" class="text-muted small ml-1">({{ uom.ml }} ml)</span>
                </td>
                <td>
                  <input type="number" class="form-control form-control-sm"
                    [(ngModel)]="uom.valueGram"
                    (change)="changeRecipeUomValue(i)"
                    min="0" step="0.01"
                    style="max-width: 110px;">
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-link text-danger p-0"
                    (click)="deleteRecipeUomRow(i)">
                    <i class="ft-trash-2"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="ingredients-totals-card mt-3" *ngIf="preferredRecipeUomNutritionObj">
            <div class="ingredients-totals-card__header">
              <i class="ft-bar-chart-2"></i>
              <span>Nutrition Summary (Selected UOM)</span>
            </div>
            <div class="ingredients-totals-card__grid">
              <div class="total-stat">
                <span class="total-stat__value">{{ preferredRecipeUomNutritionObj.weight }}g</span>
                <span class="total-stat__label">Total Weight</span>
              </div>
              <div class="total-stat total-stat--cal">
                <span class="total-stat__value">{{ preferredRecipeUomNutritionObj.calories }}</span>
                <span class="total-stat__label">Calories (kcal)</span>
              </div>
              <div class="total-stat total-stat--carb">
                <span class="total-stat__value">{{ preferredRecipeUomNutritionObj.carbs }}g</span>
                <span class="total-stat__label">Carbohydrates</span>
              </div>
              <div class="total-stat total-stat--protein">
                <span class="total-stat__value">{{ preferredRecipeUomNutritionObj.protein }}g</span>
                <span class="total-stat__label">Protein</span>
              </div>
              <div class="total-stat total-stat--fat">
                <span class="total-stat__value">{{ preferredRecipeUomNutritionObj.fat }}g</span>
                <span class="total-stat__label">Fat</span>
              </div>
              <div class="total-stat total-stat--fiber">
                <span class="total-stat__value">{{ preferredRecipeUomNutritionObj.fiber }}g</span>
                <span class="total-stat__label">Fiber</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="recipeUoms.length === 0" class="ingredients-empty ingredients-empty--compact">
          <div class="ingredients-empty__icon"><i class="ft-layers"></i></div>
          <h5 class="ingredients-empty__title">No Recipe UOM added yet</h5>
          <p class="ingredients-empty__text">Click "Add Recipe UOM" to define serving sizes.</p>
        </div>
      </div>
    </div>

    <!-- Section 9 Storage -->
    <div *ngIf="activeTab === 9" class="saru-editor__section">
      <div class="saru-field" [class.saru-field--error]="hasFieldError('storageTypeId')">
        <label>Storage Type</label>
        <ng-select [items]="lookups.storageTypes" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.storageTypeId"
          (ngModelChange)="clearFieldError('storageTypeId')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('storageTypeId')">{{ getFieldError('storageTypeId') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('shelfLifeUnit')">
        <label>Shelf Life Unit</label>
        <ng-select [items]="shelfLifeUnits" placeholder="Select unit"
          [(ngModel)]="selections.shelfLifeUnit"
          (ngModelChange)="clearFieldError('shelfLifeUnit')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('shelfLifeUnit')">{{ getFieldError('shelfLifeUnit') }}</div>
      </div>
      <div class="saru-readonly" [class.saru-field--error]="hasFieldError('shelfLife') || hasFieldError('storageInstructions')">
        <div><strong>Shelf Life:</strong> {{ parsed.shelfLife || '—' }}</div>
        <div><strong>Storage Instructions:</strong> {{ parsed.storageInstructions || '—' }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('shelfLife')">{{ getFieldError('shelfLife') }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('storageInstructions')">{{ getFieldError('storageInstructions') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('reheatMethodId')">
        <label>Reheat Method</label>
        <ng-select [items]="lookups.reheatMethods" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.reheatMethodId"
          (ngModelChange)="clearFieldError('reheatMethodId')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('reheatMethodId')">{{ getFieldError('reheatMethodId') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('reheatTemperatureUnit')">
        <label>Reheat Temperature Unit</label>
        <ng-select [items]="temperatureUnits" placeholder="Select unit"
          [(ngModel)]="selections.reheatTemperatureUnit"
          (ngModelChange)="clearFieldError('reheatTemperatureUnit')" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('reheatTemperatureUnit')">{{ getFieldError('reheatTemperatureUnit') }}</div>
      </div>
      <div class="saru-readonly" [class.saru-field--error]="hasFieldError('reheatTemperature') || hasFieldError('reheatingInstructions') || hasFieldError('ccpNotes')">
        <div><strong>Reheat Temperature:</strong> {{ parsed.reheatTemperature || '—' }}</div>
        <div><strong>Reheating Instructions:</strong> {{ parsed.reheatingInstructions || '—' }}</div>
        <div><strong>CCP (Critical Control Points):</strong> {{ parsed.ccpNotes || '—' }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('reheatTemperature')">{{ getFieldError('reheatTemperature') }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('reheatingInstructions')">{{ getFieldError('reheatingInstructions') }}</div>
        <div class="saru-field__error" *ngIf="hasFieldError('ccpNotes')">{{ getFieldError('ccpNotes') }}</div>
      </div>
    </div>

    <!-- Section 11 Media readonly -->
    <div *ngIf="activeTab === 11" class="saru-editor__section saru-readonly">
      <div><strong>Video URL:</strong> {{ parsed.videoReferenceUrl || '—' }}</div>
      <div><strong>Costing Notes:</strong> {{ parsed.costingNotes || '—' }}</div>
      <div *ngIf="selections.thumbnailImagePath" class="saru-readonly" style="margin-top: 8px;">
        <strong>Thumbnail:</strong> set in preview table
      </div>
      <p class="saru-hint" *ngIf="!selections.thumbnailImagePath">
        Optional: upload a thumbnail from the preview table Image column before import.
      </p>
    </div>

    <!-- Status -->
    <div *ngIf="activeTab === 12" class="saru-editor__section">
      <div class="saru-field" [class.saru-field--error]="hasFieldError('assignment')">
        <label>Workflow Status</label>
        <ng-select [items]="statusOptions" bindLabel="label" bindValue="value"
          [(ngModel)]="selections.status" [clearable]="false" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('assignment')">{{ getFieldError('assignment') }}</div>
        <p class="saru-hint" *ngIf="selections.status === 'Assigned to Maker' || selections.status === 'Assigned to Checker'">
          Assignment is configured from the preview Status dropdown (Maker &amp; Checker popup).
        </p>
      </div>
    </div>
      </div>
    </div>
  </div>

  <div class="saru-editor__footer">
    <button type="button" class="btn btn--outline" (click)="activeModal.dismiss()">Cancel</button>
    <button type="button" class="btn btn--primary" (click)="save()">
      <i data-lucide="check"></i> Save Row Config
    </button>
  </div>
</div>

<!-- Add Ingredient sub-dialog (NgbModal — avoids nested fixed overlay glitch) -->
<ng-template #ingredientDialogTpl let-modal>
  <div class="saru-subdialog">
    <div class="saru-subdialog__header">
      <div class="saru-subdialog__header-icon">
        <i class="ft-plus-circle" *ngIf="ingredientEditIndex == null"></i>
        <i class="ft-edit-2" *ngIf="ingredientEditIndex != null"></i>
      </div>
      <h4 class="saru-subdialog__title">
        {{ ingredientEditIndex != null ? 'Edit' : 'Add' }} Ingredient
      </h4>
      <button type="button" class="saru-subdialog__close" (click)="modal.dismiss()">
        <i class="ft-x"></i>
      </button>
    </div>
    <div class="saru-subdialog__body">
      <div class="ingredient-field">
        <label class="ingredient-field__label">
          Ingredient Name
        </label>
        <ng-select placeholder="Search ingredient..."
          [items]="ingredientSearchResults"
          bindLabel="name" bindValue="id"
          [(ngModel)]="selectedIngredientId"
          (search)="onIngredientSearch($event)"
          (change)="onIngredientSelected(selectedIngredientId!)"
          [loading]="ingredientSearchLoading"
          [searchFn]="ingredientServerSearchFn"
          [minTermLength]="2"
          typeToSearchText="Type 2+ characters to search..."
          class="ingredient-select"
          appendTo="body">
        </ng-select>
      </div>
      <div class="ingredient-field-row">
        <div class="ingredient-field ingredient-field--half">
          <label class="ingredient-field__label">
            Unit
          </label>
          <ng-select placeholder="Select Unit"
            [items]="ingredientServingUnits"
            bindLabel="displayLabel"
            bindValue="servingUnitMasterId"
            [(ngModel)]="selectedServingUnitId"
            (change)="onServingUnitChange()"
            class="ingredient-select"
            appendTo="body">
          </ng-select>
        </div>
        <div class="ingredient-field ingredient-field--half">
          <label class="ingredient-field__label">
            Quantity
          </label>
          <input type="number" class="ingredient-input"
            [(ngModel)]="ingredientQuantity"
            (input)="onIngredientQuantityChange()"
            min="0.01" step="0.01"
            placeholder="Enter quantity">
        </div>
      </div>
      <div class="ingredient-total-display" *ngIf="ingredientTotalGrams > 0">
        <div class="ingredient-total-display__icon"><i class="ft-zap"></i></div>
        <div class="ingredient-total-display__content">
          <span class="ingredient-total-display__label">Total Quantity</span>
          <span class="ingredient-total-display__value">
            {{ ingredientTotalGrams.toFixed(2) }} grams
          </span>
        </div>
      </div>
    </div>
    <div class="saru-subdialog__footer">
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--cancel"
        (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--submit"
        [disabled]="!selectedIngredientId || !selectedServingUnitId || !ingredientQuantity || ingredientQuantity <= 0"
        (click)="saveRecipeIngredient()">
        <i class="ft-check mr-1"></i>
        {{ ingredientEditIndex != null ? 'Update' : 'Add' }} Ingredient
      </button>
    </div>
  </div>
</ng-template>

<!-- Add Recipe UOM sub-dialog -->
<ng-template #recipeUomDialogTpl let-modal>
  <div class="saru-subdialog">
    <div class="saru-subdialog__header">
      <div class="saru-subdialog__header-icon"><i class="ft-grid"></i></div>
      <h5 class="saru-subdialog__title">Add Recipe UOM</h5>
      <button type="button" class="saru-subdialog__close" (click)="modal.dismiss()">
        <i class="ft-x"></i>
      </button>
    </div>
    <div class="saru-subdialog__body">
      <div class="uom-form-row">
        <div class="uom-field">
          <label class="form-label">Category</label>
          <ng-select placeholder="Select Category"
            [items]="recipeUomCategories"
            bindLabel="name"
            bindValue="id"
            [(ngModel)]="selectedUomCategoryId"
            (change)="onUomCategoryChange()"
            class="ingredient-select"
            appendTo="body">
          </ng-select>
        </div>
        <div class="uom-field">
          <label class="form-label">Sub Category</label>
          <ng-select placeholder="Select Sub Category"
            [items]="recipeUomSubcategories"
            bindLabel="name"
            bindValue="id"
            [(ngModel)]="selectedUomSubcategoryId"
            class="ingredient-select"
            appendTo="body">
          </ng-select>
        </div>
        <div class="uom-action">
          <button type="button"
            class="btn btn-primary btn-sm uom-add-btn"
            [disabled]="!selectedUomCategoryId || !selectedUomSubcategoryId || recipeUomLoading"
            (click)="addRecipeUomFromDialog()">
            <i class="ft-plus mr-1" *ngIf="!recipeUomLoading"></i>
            <i class="ft-loader ft-spin mr-1" *ngIf="recipeUomLoading"></i>
            Add
          </button>
        </div>
      </div>
    </div>
    <div class="saru-subdialog__footer">
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--cancel"
        (click)="modal.dismiss()">Close</button>
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--submit"
        (click)="saveRecipeUomSelection()">
        <i class="ft-check mr-1"></i> Done
      </button>
    </div>
  </div>
</ng-template>
